import "core-js/modules/es.object.assign";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2017,2019. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */


import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { getOtherProps } from '../util';

var Main = function Main(props) {
  var pushFooter = props.pushFooter,
      children = props.children,
      gradient = props.gradient,
      className = props.className;
  var otherProps = getOtherProps(Main.propTypes, props);
  var stylingClass = classnames('wds-l-main', {
    'wds-l-main--push-footer': pushFooter
  }, {
    'wds-c-section--primary': gradient
  }, className);
  return React.createElement("main", _extends({
    role: "main",
    className: stylingClass
  }, otherProps), children);
};

Main.propTypes = {
  /** if set to true, the footer stays at the bottom of the visible
   * page unless the content of the page is tall enough to push it
   * down */
  pushFooter: PropTypes.bool,

  /** children  */
  children: PropTypes.node.isRequired,

  /** additional styling */
  className: PropTypes.string,

  /** specifies if the background should be the blue gradient style */
  gradient: PropTypes.bool
};
Main.defaultProps = {
  pushFooter: false,
  className: undefined,
  gradient: false
};
export default Main;